<template>
  <div id="app">
    <Navbar />
    <router-view />
  </div>
</template>

<script lang="ts">
import Navbar from "./components/Navbar.vue";

export default {
  components: { Navbar },
  name: "App"
};
</script>

<style lang="scss">
@import "~@storefront-ui/vue/styles.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  @include generate-color-variants(--c-primary, #ca0074);
  // --c-primary: #ca0074;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
}
</style>
